import { ApiHelper } from './api.helper';
import { IStaffStatus } from '../types/staff-status';
import { HttpUtils } from '../utils/http.utils';
import { IFilters, IRequestParams } from '../views/StaffStatus/types';

export const fetchStaffStatus = async (filters: IFilters): Promise<IStaffStatus[]> => {
  const queryParams = HttpUtils.toQueryParams<IFilters, IRequestParams>(filters);
  const url = `${ApiHelper.makeUrl('staff/status')}?${queryParams}`;
  const response = await fetch(url, ApiHelper.makeOptions());
  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message);
  }

  return data;
};
export const downloadStaffStatus = async (filters: IFilters): Promise<Blob> => {
  const queryParams = HttpUtils.toQueryParams<IFilters, IRequestParams>(filters);
  const url = `${ApiHelper.makeUrl('staff/status/export')}?${queryParams}`;

  const response = await fetch(url, ApiHelper.makeOptions());
  const data = response.blob();

  if (!response.ok) {
    const responseData = await response.json();

    throw new Error(await responseData.message);
  }

  return data;
};
